import {
  formatPurchasePlanningCashRequired,
  formatPurchasePlanningNumber,
  formatPurchasePlanningPercent,
} from '../../../lib/purchasePlanningHelpers';

export function PurchaseRoundingPoolRail({ highlightedGroups, onSelectGroup }) {
  return (
    <aside className="rounded-lg border border-gray-200 bg-white p-2 lg:p-4">
      <div>
        <h3 className="text-sm font-semibold text-gray-900">Container pools driving rounding</h3>
        <p className="mt-1 text-xs text-gray-500">
          These supplier pools explain where shared container capacity changes the final purchasable quantity.
        </p>
      </div>
      <div className="mt-4 space-y-2">
        {highlightedGroups.length > 0 ? (
          highlightedGroups.map(group => (
            <button
              key={group.id}
              type="button"
              className="flex w-full items-start justify-between rounded-md border border-gray-200 bg-white px-1.5 py-1.5 text-left transition hover:border-gray-300 lg:px-3 lg:py-3"
              onClick={() => onSelectGroup?.(group.id)}
            >
              <div className="min-w-0 pr-3">
                <p className="truncate text-sm font-medium text-gray-900">{group.containerGroup}</p>
                <p className="mt-1 truncate text-xs text-gray-500">{group.supplier}</p>
                <p className="mt-2 text-[11px] uppercase tracking-[0.12em] text-gray-500">
                  {formatPurchasePlanningNumber(group.skuCount)} SKU
                  {group.skuCount === 1 ? '' : 's'}
                </p>
              </div>
              <div className="text-right">
                <p className="text-sm font-semibold text-gray-900">
                  {formatPurchasePlanningNumber(group.fillUnits)} fill
                </p>
                <p className="mt-1 text-xs text-gray-500">
                  {formatPurchasePlanningPercent(group.preFillUtilization)} pre-fill
                </p>
                <p className="mt-2 text-[11px] text-gray-500">
                  {formatPurchasePlanningCashRequired(group.totalCashRequired)}
                </p>
              </div>
            </button>
          ))
        ) : (
          <div className="rounded-md border border-dashed border-gray-200 bg-white px-4 py-6 text-sm text-gray-500">
            No pooled container groups are in scope for the current filters.
          </div>
        )}
      </div>
    </aside>
  );
}
